import React from 'react';
import {MasterLayout} from 'layout';

let nfIcon = require('assets/images/file-nf.svg');
class Page403 extends React.Component {
 
  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
        <div className="panel-page">
          <div className="center">                
            <div className="main_page">                    
              <div className="wrapper_box tc-box not-found">
                <div className="box">
                  <img src={nfIcon} alt="not-found" />
                  <div className="content">
                    <p>
                      Bạn không có quyền xem chi tiết đơn này
                    </p>                   
                  </div>
                </div>
              </div>                  
            </div>             
          </div>
        </div>
      </MasterLayout>
    );
  }
}

export default Page403;


// WEBPACK FOOTER //
// ./src/components/modules/home/Page403.jsx